import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AutoSigninPopup from "./components/Autosignin.js";
import CustomerReviews from "./components/CustomerReviews.js";
import Footer from "./components/Footer.js";
import Navbar from "./components/Navbar.js";
import { subscribeProducts } from "./store/productsSlice.js";
import { subscribeOrders } from "./store/ordersSlice.js";
import { subscribeSpecialOffers } from "./store/specialOffersSlice.js";

const Layout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const user = useSelector((s) => s.auth.user);

  // Start real-time Firebase listeners once on mount — works for all users on any device
  useEffect(() => {
    dispatch(subscribeProducts());
    dispatch(subscribeSpecialOffers());
  }, [dispatch]);

  // Subscribe orders filtered by userId for regular users, all orders for admin
  useEffect(() => {
    if (user?.isAdmin) {
      dispatch(subscribeOrders(null)); // all orders for admin
    } else if (user?.uid) {
      dispatch(subscribeOrders(user.uid)); // only their orders
    }
  }, [dispatch, user?.uid, user?.isAdmin]);

  return (
    <div className="d-flex flex-column min-vh-100">
      {!isAdmin && <Navbar />}

      <main className="flex-grow-1">
        <Outlet />
        {!isAdmin && <AutoSigninPopup />}
      </main>

      {!isAdmin && <CustomerReviews />}
      {!isAdmin && <Footer />}
    </div>
  );
};

export default Layout;
